import React, { Component } from 'react';
import './NotFoundRoute.css';
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'

class NotFoundRoute extends Component {

  render() {
    document.title ="Kayn | Sign Up"; 
        document.getElementsByTagName("META")[1].content="Kayn Sign Up";
          const url = window.location.pathname.slice(1,3)
          console.log(url)
    return (
      <div className="NotFoundRoute">
          <Navbar />

        {(url === 'AR/'||url==='ar/'?<div><div class="hit-the-floor">404</div>
    <p className="text-center  hit-the-floor2 ">الصفحه غير موجوده</p></div>:
    <div><div class="hit-the-floor">404</div>
    <p className="text-center  hit-the-floor2 ">Sorry! Page not found</p></div>)}
    <hr/>
          <Footer/>
      </div>
    )
  }
} 
export default NotFoundRoute;